import { SettingConst } from '@faire/web-api--source/types';

/**
 * How many brands we have on the platform, rounded to a nice number we're comfortable disclosing for marketing purposes
 */
export const HOME_PAGE_MAKER_COUNT = 'HOME_PAGE_MAKER_COUNT' as SettingConst<
  'HOME_PAGE_MAKER_COUNT',
  number,
  | 'RETAILER'
  | 'RETAILER_HEAD_TAGS'
  | 'VISITOR_WEB'
  | 'MAKER'
  | 'RETAILER_IOS'
  | 'RETAILER_ANDROID'
>;
